/**
 * Created by sivanh on 12/06/2018.
 */
define(function (require) {
    "use strict";
    var LE = require("app");
    var InputField = require("ui/input-field/InputField");
    var Button = require("ui/button/Button");
    var InlineTextarea = require("ui/inline-textarea/InlineTextarea");
    var Dropdown = require("ui/dropdown/Dropdown");

    var ScheduleEventsListView = require("manager-views/schedule/ScheduleEventsListView");
    var template = require("manager-templates/schedule/scheduleEditView.tmpl");


    var CONST = {
        SCHEDULE_NAME_MAX_LENGTH: 50
    };

    var ScheduleEditView = {};
    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        ScheduleEditView = Marionette.ItemView.extend({
            className: "schedule-edit-view",
            template: template,
            ui: {
                nameInputContainer: ".schedule-name-wrapper .input-container",
                descriptionContainer: ".schedule-description",
                timezoneContainer: ".schedule-time-zone-wrapper .dropdown-container",
                scheduleListContainer: ".schedule-list-container",
                saveButtonContainer: ".button-save",
                cancelButtonContainer: ".button-cancel"
            },
            uiComponents: {
                name: {
                    type: InputField,
                    options: {
                        el: "view.ui.nameInputContainer",
                        maxLength: CONST.SCHEDULE_NAME_MAX_LENGTH,
                        permutation: InputField.Permutation.B,
                        inputType: InputField.prototype.InputTypeEnum.AlphaNumeric,
                        value: "view._getWorkdaysName"
                    },
                    events: {
                        "change": "_onWorkdaysNameChange"
                    }
                },
                description: {
                    type: InlineTextarea,
                    options: {
                        container: "view.ui.descriptionContainer",
                        permutation: InlineTextarea.PERMUTATION.A,
                        value: "view._getDescription"
                    },
                    events: {
                        "change": "_onDescriptionChange"
                    }
                },
                timezone:{
                    type: Dropdown,
                    options:{
                        container: "view.ui.timezoneContainer",
                        items: "view._getTimezoneOptions",
                        selectedOption: "view._getSelectedTimezone",
                        testCollision: true,
                        collisionWithinSelector: ".le .manager-region .schedule-edit-view .view-container"
                    },
                    events:{
                        "change":"_onTimezoneDropdownChange"
                    }
                },
                scheduleList: {
                    type: ScheduleEventsListView,
                    options: {
                        collection: "view._getScheduleList",
                        container: "view.ui.scheduleListContainer",
                        channel: "view.channel"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButtonContainer",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT,
                        initState: Button.STATES.ENABLED,
                    },
                    events: {
                        "click": "_onSave"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButtonContainer",
                        permutation: Button.PERMUTATION.LINK,
                        initState: Button.STATES.ENABLED
                    },
                    events: {
                        "click": "_onCancel"
                    }
                }
            },

            initialize: function(options) {
                this._initialize(options);
            },

            onRender: function() {
                this._onRender();
            },

            onInvalid: function (model, errors) {
                this._onInvalid(model, errors);
            },

            _initialize: function(options) {
                this.channel = options.channel;
            },

            _onRender: function() {
                this._bindEvents();
                this._updateSaveButtonState();
            },

            _bindEvents: function() {
                this.listenTo(this.model, "change", this._updateSaveButtonState);
                this.listenTo(this, "page:closeButtonClick", this._onCancel);
                this.listenTo(this.channel.vent, "save:error", this._onInvalid);
            },

            _getWorkdaysName: function() {
                return this.model.getName();
            },

            _onWorkdaysNameChange: function(componentId, eventName, name) {
                this.channel.trigger("ScheduleEditView:change:name",name);
            },

            _getDescription: function () {
                return this.model.getDescription();
            },

            _onDescriptionChange: function(componentId, eventName, description) {
                this.channel.trigger("ScheduleEditView:change:description",description);
            },

            _getTimezoneOptions: function() {
                var timezoneList = LE.siteSettings.timeZoneSettings.getTimeZoneListTranslated();
                _.each(timezoneList, function(item){
                    item.searchKey = item.value.substring(12,item.value.length).trim().toLowerCase();
                });
                return new Dropdown.Collection(timezoneList);
            },

            _getSelectedTimezone: function () {
                return this.model.getTimezone();
            },

            _onTimezoneDropdownChange: function (componentId, eventName, selectedObject){
                var selectedKey = selectedObject.selectedKey;
                this.channel.trigger("ScheduleEditView:change:timezone", selectedKey);
            },

            _getScheduleList: function () {
                return this.model.getScheduleEventsCollection();
            },

            _onInvalid: function(model, errors) {
                this._hideErrors();

                if (_.has(errors, this.model.KEYS.NAME)) {
                    this.uiComponents.name.setError(true, errors[this.model.KEYS.NAME]);
                }
                if (_.has(errors, this.model.KEYS.DESCRIPTION)) {
                    this.uiComponents.description.setError(true, errors[this.model.KEYS.DESCRIPTION]);
                }
            },

            _hideErrors: function() {
                this.uiComponents.name.setError(false);
                this.uiComponents.description.setError(false);
            },

            _onSave: function() {
                this.channel.trigger("ScheduleEditView:save");
            },

            _onCancel: function() {
                this.channel.trigger("ScheduleEditView:cancel");
            },

            _updateSaveButtonState: function () {
                var isModelValid = this.model.validateMandatoryFilled();

                if (!isModelValid) {
                    this.uiComponents.saveButton.setEnabled(false);
                    this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEManager.scheduleEditView.saveButton.tooltip.mandatoryFields"));
                }
                else {
                    this.uiComponents.saveButton.setEnabled(true);
                    this.uiComponents.saveButton.setTooltip("");
                }
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return ScheduleEditView;
});
